module.exports = __webpack_public_path__ + "static/media/kakis1.710f9799.png";